import { Component, OnDestroy } from '@angular/core';
import { ModalController, NavParams, ToastController,ViewController } from 'ionic-angular';
import { Storage } from '@ionic/storage';
import { TranslateService } from '@ngx-translate/core';
import { provider } from '../../../providers/provider';
import { HttpClient } from '@angular/common/http';
import { Subject } from 'rxjs';
import { CustomizerProvider } from '../../../providers/customizer/customizer';

@Component({
  selector: 'page-modalVerificaUtente',
  templateUrl: 'modalVerificaUtente.html'
})
export class ModalVerificaUtente implements OnDestroy {
  private _onDestroy = new Subject();
  content; 
  count = 31;
  verification = { code: '' };
  show = false;
  method;

  constructor(
    public translateService: TranslateService, 
    public viewCtrl: ViewController, 
    public toastCtrl: ToastController, 
    public storage: Storage, 
    public provider: provider, 
    public modalCtrl: ModalController, 
    public http: HttpClient, 
    public customizer: CustomizerProvider,
    params: NavParams) {

      setTimeout(function(){ 
        this.show = true
      }, 30000);

      this.method = params.get('method');
    }

  sendVerificationCode() {
    if(this.verification.code == '') 
      return;
    
    this.viewCtrl.dismiss(this.verification.code);
  }

  // Handle error shows a translated error messages
  // if message is an error-coded one, or a generic message
  handleError(message: string) {
    var translatedMessage : string;
    if (!message.startsWith("E") || message.length != 5) {
      message = 'E9999';
    } 
    this.translateService
      .get(message)
      .takeUntil(this._onDestroy)
      .subscribe(value => { translatedMessage = value });                     
    let toast = this.toastCtrl.create({
      message: translatedMessage,
      duration: 3000,
      position: 'middle'
    });
    toast.present();
  }

  ngOnDestroy() {
    this._onDestroy.next();
  }

  dismiss() {
    this.viewCtrl.dismiss();
  }

}



// WEBPACK FOOTER //
// ./src/pages/account/modalVerificaUtente/modalVerificaUtente.ts